import React from 'react';

export function useAsyncEffect(effect: (isMounted: () => boolean) => unknown | Promise<unknown>, inputs?: any[]): void;
export function useAsyncEffect<V>(
  effect: (isMounted: () => boolean) => V | Promise<V>,
  destroy?: (result?: V) => void,
  inputs?: any[],
): void;
export function useAsyncEffect(
  effect: (isMounted: () => boolean) => unknown | Promise<unknown>,
  destroy?: any,
  inputs?: any,
) {
  const hasDestroy = typeof destroy === 'function';

  React.useEffect(
    function () {
      let result: any;
      let mounted = true;
      const maybePromise = effect(function () {
        return mounted;
      });

      Promise.resolve(maybePromise).then(function (value) {
        result = value;
      });

      return function () {
        mounted = false;

        if (hasDestroy) {
          destroy(result);
        }
      };
    },
    hasDestroy ? inputs : destroy,
  );
}
